import { Reducer } from 'interfaces'
import { VideoCallsAppState, PermissionsState } from 'components/features/videoCalls/types/state'
import { UpdateMediaPermissionsAction, SetMediaPermissionsAction } from 'components/features/videoCalls/types/actions'

const INITIAL_STATE = new PermissionsState()
export const permissionsReducer: Reducer<VideoCallsAppState['permissions']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case UpdateMediaPermissionsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { cam, mic } = action.payload.response

      return {
        ...prevState,
        ...cam !== undefined ? { cam } : {},
        ...mic !== undefined ? { mic } : {},
      }
    }

    case SetMediaPermissionsAction.type: {
      const { cam, mic } = action.payload

      return {
        ...prevState,
        ...cam !== undefined ? { cam } : {},
        ...mic !== undefined ? { mic } : {},
      }
    }
  }
  return prevState
}
